import { combineReducers } from 'redux'
import questions from '../questions'
import question from '../question'
import user from '../user'

export default combineReducers({
  [questions.constants.NAME]: questions.reducer,
  [question.constants.NAME]: question.reducer,
  [user.constants.NAME]: user.reducer
})



// WEBPACK FOOTER //
// ./src/app/reducer.js